import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreTestimonials } from "../../api/apiTestimonials";
import parseError from "../../utils/parseError";

export function useRestoreAllTestimonials() {
    const queryClient = useQueryClient();

    const { mutate: restoreAllItemsMutate, isPending } = useMutation({
        mutationFn: massRestoreTestimonials,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["testimonials"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore testimonials");
        },
    });

    return { restoreAllItemsMutate, isPending };
}
